<template>
  <div>
    <section class="banner">
      <div class="container text-center">
        <h1>Release Notes</h1>
      </div>
    </section>
    <section class="releasenotes">
      <div class="releasedetails" v-for="release in releases" v-bind:key="release.id">
        <div class="version">
          <h2>
            {{ release.versao }}
            <footer class="blockquote-footer">{{ release.data }}</footer>
          </h2>
        </div>
        <div class="details">
          <p class="titulo" v-if="release.funcionalidades && release.funcionalidades.length">Funcionalidades</p>
          <ul>
            <li v-for="funcionalidade in release.funcionalidades" v-bind:key="funcionalidade">
              <span v-html="funcionalidade.texto"></span>
              <p v-if="funcionalidade.observacao" v-html="funcionalidade.observacao"></p>
            </li>
          </ul>

          <p class="titulo" v-if="release.melhorias && release.melhorias.length">Melhorias</p>
          <ul>
            <li v-for="melhoria in release.melhorias" v-bind:key="melhoria">
              {{ melhoria.texto }}
              <p v-if="melhoria.observacao">{{ melhoria.observacao }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ReleaseNotesView',
  data () {
    return {
      estrutura_release: {
        versao: '',
        data: '',
        funcionalidades: [
          { texto: '', observacao: '' }
        ],
        melhorias: [
          { texto: '', observacao: '' }
        ]
      },
      releases: [
        {
          versao: 'v 1.6.0-a',
          data: '03/01/2020',
          funcionalidades: [
            { texto: '[Dashboard] Criar os endpoints da API para desempenho do usuário por disciplina' },
            { texto: '[Dashboard] Criar os endpoints da API para desempenho do usuário por curso' },
            { texto: '[Dashboard] Consumir endpoints do gráfico de desempenho por disciplina' },
            { texto: '[Dashboard] Consumir endpoints do gráfico de desempenho por curso' },
            { texto: '[Login] Criar endpoints da API do login de Admin.' },
            { texto: '[Login] Consumir endpoints da API do login de Admin' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.5.0-a',
          data: '23/12/2019',
          funcionalidades: [
            { texto: '[Painel de Análise - Geral] Implementar filtro pro range de data' },
            { texto: '[Conta - Admin] Consumir endpoints da API de redefinição de senha.' },
            { texto: '[Conta - Admin] Criar endpoints da API de redefinição de senha.' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.4.0-a',
          data: '16/12/2019',
          funcionalidades: [
            { texto: '[Home] Criar os endpoints da API para downloads realizados por usuário (Painel de Análise do Admin - Usuários)' },
            { texto: '[Home] Consumir os endpoints da API para downloads realizados por usuário (Painel de Análise do Admin - Usuários)' },
            { texto: '[Admin - Painel de Análise] Criar os endpoints da API do gráfico de questões respondidas.' },
            { texto: '[Admin - Painel de Análise] Consumir os endpoints da API do gráfico de questões respondidas.' },
            { texto: '[Painel de Análise - Admin] Criar endpoints da API de vídeos assistidos (em horas) - Painel de Análise por usuário' },
            { texto: '[Painel de Análise - Admin] Consumir endpoints da API de vídeos assistidos (em horas) - Painel de Análise por usuário' },
            { texto: '[Painel de Análise - Admin] Criar um filtro por range de data' },
            { texto: '[Home] Criar os endpoints da API para acessos em tópicos (Painel de Análise do Admin - Usuários)' },
            { texto: '[Home] Consumir os endpoints da API para acessos em tópicos (Painel de Análise - Admin - Usuários' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.3.0-a',
          data: '09/12/2019',
          funcionalidades: [
            { texto: '[Conta - Admin] Consumir endpoints da API para gestão de usuários da conta de uma instituição', observacao: 'Implementação do consumo das APIs de edição e criação de usuários. Ainda pendente a redefinição de senha' },
            { texto: '[Conta - Admin] Criar endpoint para API de criação de cadastro de usuário  único' },
            { texto: '[Conta - Admin] Implementar página de cadastro de usuário único no Admin' },
            { texto: '[Conta - Admin] Consumir endpoint da API para a criação de cadastro de usuário único no Admin.' },
            { texto: '[Conta - Admin] Alterar campos de formulário de cadastro de acordo com o perfil de usuário selecionado.' },
            { texto: '[Conta - Admin] Implementar importação de lista de usuários' },
            { texto: '[Conta - Admin] Consumir endpoints de importação de lista de usuários.' },
            { texto: '[Conta - Admin] Criar endpoints para a importação de lista de usuários' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.2.0-a',
          data: '29/11/2019',
          funcionalidades: [
            { texto: '[Login] Criação de Login básico para já manter a API do Admin autenticada', observacao: 'Foi criado um layout base inicial. Quando tivermos a página de login no protótipo, deveremos substituir' },
            { texto: '[Conta - Admin] Criar endpoints da API para gestão de usuários da conta de uma instituição', observacao: 'Criação dos endpoints de listagem de usuários, bloquear, desbloquear e excluir. O bloqueio está utilizando a coluna "deletado" até que uma estrutura seja criada para o bloqueio. A exclusão também não está excluindo fisicamente ainda. Preferi manter desse jeito até implementarmos a criação de usuários.' },
            { texto: '[Conta - Admin] Consumir endpoints da API para gestão de usuários da conta de uma instituição', observacao: 'Consumo dos endpoints citados acima' },
            { texto: '[Conta - Admin] Exportar lista de usuários' },
            { texto: '[Conta - Admin] Implementar página da gestão de usuários' },
            { texto: '[Conta - Admin] Consumir endpoints da API para gestão de usuários da conta de uma instituição', observacao: 'Resta ainda consumir endpoints de criação e edição de usuários' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.1.0-a',
          data: '11/11/2019',
          funcionalidades: [
            { texto: '[Home] Criar os endpoints da API para média de questões respondidas por usuário (Painel de Análise do Admin - Usuários)' },
            { texto: '[Home] Criar os endpoints da API para média de horas de vídeo assistidas por usuário (Painel de Análise do Admin - Usuários)' }
          ],
          melhorias: []
        },
        {
          versao: 'v 1.0.0-a',
          data: '04/11/2019',
          funcionalidades: [
            { texto: '[Infraestrutura] Criar estrutura do projeto do Jaleko Admin B2B' },
            { texto: '[Infraestrutura] Realizar commit do projeto no bitbucket da Jaleko' },
            { texto: '[Infraestrutura] Disponibilizar Admin em ambiente de desenvolvimento Heroku' },
            { texto: '[Home] Levantar Requisitos de Banco pros Gráficos do Admin e Sugerir Ajustes' },
            {
              texto: '[Dashboard] Criar os endpoints da API para Painel de Análise do Admin - Geral',
              observacao: 'Pendente API de Acesso de Usuários x Tópicos acessados, pois ainda está com pendências de definição (eixos a exibir, possibilidade de virar 2 gráficos, etc)<br>Pendente também a API de termos mais pesquisados, montei uma com dados fakes'
            },
            { texto: '[Dashboard] Front da dashboard Geral' },
            { texto: '[Dashboard] Consumir os endpoints da API do Painel de Análise do Admin - Geral' }
          ],
          melhorias: []
        }
      ]
    }
  }
}
</script>

<style scoped>
  section.banner {
    position: relative;
    color: #FFF;
    padding-top: 5px;
    border-bottom: 20px solid #7C56F6;
  }

  section.banner h1 {
    background-color: rgba(77, 205, 204, 0.8);
    padding: 10px;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 5px;
    height: 100%;
  }

  section.releasenotes {
    z-index: 99;
    position: relative;
  }

  section.releasenotes div.releasedetails {
    background-color: #4DCDCC;
    padding-bottom: 60px;
    margin: 50px 0 80px;
  }

  section.releasenotes div.releasedetails h2::before {
    background-color: #7C56F6;
  }

  section.releasenotes h2::before {
    content: "";
    transform: skewX(-10deg);
    background-color: #4DCDCC;
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }

  section.releasenotes h2 {
    color: #FFF;
    padding: 10px 18px;
    display: inline-block;
    position: relative;
    margin-top: -50px;
    z-index: 9;
    letter-spacing: normal;
    font-size: 16px;
    font-weight: bold;
    text-transform: none;
  }

  section.releasenotes h2 .blockquote-footer {
    display: block;
    font-size: 80%;
    background-color: transparent;
    color: #FFF;
    padding-top: 5px;
    padding-bottom: 0px;
    margin-left: 10px;
}

section.releasenotes div.releasedetails p.titulo {
  color: #FFF;
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0 10px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.31);
}

section.releasenotes div.releasedetails ul {
  list-style-type: disc;
  padding-left: 1em;
  margin-left: 1em;
}

section.releasenotes div.releasedetails ul li {
  font-size: 14px;
  line-height: 20px;
}

section.releasenotes div.releasedetails ul li p {
  font-size: 12px;
  margin-left: 10px;
  font-weight: bold;
}

section.releasenotes div.releasedetails p {
  text-align: left;
}

section.releasenotes div.releasedetails .details {
  margin-left: 15px;
}

section.releasenotes div.releasedetails .version {
  margin-left: 14px;
}

</style>
